import { DEFAULT_CONFIG, type AppConfig, type DailyPayload, type DailyRecord } from "../../shared/domain";

export const todayInJapan = () =>
  new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());

export const addDays = (date: string, days: number) => {
  const value = new Date(`${date}T00:00:00+09:00`);
  value.setUTCDate(value.getUTCDate() + days);
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(value);
};

export const toOffsetIso = (local: string) => (local ? `${local}:00+09:00` : "");
export const toLocalDateTime = (iso: string) => iso.slice(0, 16);

export function emptyDaily(businessDate: string, config: AppConfig = DEFAULT_CONFIG): DailyPayload {
  return {
    requestId: crypto.randomUUID(),
    expectedRevision: 0,
    businessDate,
    openingRegisterCash: config.defaultOpeningRegisterCash,
    closingRegisterCashActual: null,
    customers: [{ lineId: crypto.randomUUID(), customerLabel: "", amount: 0, memo: "" }],
    payments: { paypay: 0, card: 0, tab: 0, transferDue: 0 },
    receivables: [],
    expenses: [],
    shifts: [],
    collections: [],
    note: "",
  };
}

export function payloadFromRecord(record: DailyRecord): DailyPayload {
  return {
    requestId: crypto.randomUUID(),
    expectedRevision: record.revision,
    businessDate: record.businessDate,
    openingRegisterCash: record.openingRegisterCash,
    closingRegisterCashActual: record.closingRegisterCashActual,
    customers: record.customers,
    payments: record.payments,
    receivables: record.receivables,
    expenses: record.expenses,
    shifts: record.shifts,
    collections: record.collections,
    note: record.note,
  };
}
